import React from "react";
import { User, Check } from "lucide-react";
import { Receipt21, Send } from "iconsax-reactjs";

export interface CompleteTransferStepperProps {
  activeStep: number;
  className?: string;
}

export const CompleteTransferStepper: React.FC<CompleteTransferStepperProps> = ({
  activeStep,
  className = "",
}) => {
  const steps = [
    { id: 1, icon: User, ariaLabel: "Provider details" },
    { id: 2, icon: Receipt21, ariaLabel: "Payment information" },
    { id: 3, icon: Send, ariaLabel: "Review transfer details" },
  ];

  return (
    <div
      className={`mx-auto mb-8 flex w-full items-center justify-between ${className}`}
      role="progressbar"
      aria-valuenow={activeStep}
      aria-valuemin={1}
      aria-valuemax={3}
    >
      {steps.map((step, index) => {
        const Icon = step.icon;
        const isActive = activeStep === step.id;
        const isCompleted = activeStep > step.id;
        const hasNextLine = index < steps.length - 1;
        const isLinePassed = activeStep > step.id;

        return (
          <React.Fragment key={step.id}>
            {/* Step Icon Circle */}
            <div
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-all duration-200 ${
                isCompleted
                  ? "bg-[#EBE4FF] text-[#A173FF]"
                  : isActive
                    ? "bg-[#A173FF] text-white shadow-xs"
                    : "bg-[#EFF0FA] text-[#6F739B]"
              }`}
              aria-label={step.ariaLabel}
            >
              {isCompleted ? (
                <Check size={18} strokeWidth={2.5} className="text-[#A173FF]" />
              ) : (
                <Icon size={20} color={isActive ? "#FFFFFF" : "#6F739B"} />
              )}
            </div>

            {/* Connecting Line */}
            {hasNextLine && (
              <div
                className={`h-[1.5px] flex-1 transition-colors duration-200 ${
                  isLinePassed ? "bg-[#C4A8FF]" : "bg-[#EFF0FA]"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CompleteTransferStepper;

